var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAlertFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM7.44891 12.1162C6.79017 12.1162 6.26772 11.6214 6.26772 11.0084C6.26772 10.3954 6.79017 9.90064 7.44891 9.90064C8.10765 9.90064 8.6301 10.3954 8.6301 11.0084C8.6301 11.6214 8.10765 12.1162 7.44891 12.1162ZM6.59147 7.99117C6.63329 8.43345 7.00465 8.77136 7.44891 8.77136C7.89317 8.77136 8.26453 8.43345 8.30635 7.99117L8.64239 4.43664C8.7089 3.73312 8.15556 3.125 7.44891 3.125C6.74226 3.125 6.18892 3.73312 6.25543 4.43664L6.59147 7.99117Z",
    fill: "#C50202"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AlertFill.581d31d3.svg";
export { ForwardRef as ReactComponent };